import { useEffect } from 'react'
import { useRouter } from 'next/router'
import classes from './RelatedProducts.module.scss'
import RelatedProductCard from './RelatedProductCard'
import { dataLayerViewProductList } from '@/utils/dataLayer'

const RelatedProducts = ({ fields }) => {
  const router = useRouter()
  const {
    backgroundColor: bgColor,
    description,
    header,
    mappedProducts,
    useFlyout,
    usePricing,
    useATC,
  } = fields

  useEffect(() => {
    dataLayerViewProductList({ products: mappedProducts, url: router.asPath })
  }, [])

  return (
    <section
      style={{
        background: bgColor
          ? `rgba(${bgColor.rgb.r}, ${bgColor.rgb.g}, ${bgColor.rgb.b}, ${bgColor.rgb.a})`
          : null,
      }}
      className={`${classes['collection-list__container']}`}
    >
      <div className={`${classes['collection-list__header']} container`}>
        <div role="contentinfo">
          <h1 style={{ color: header?.headerColor?.hex }}>
            {header?.headerText}
          </h1>
        </div>
        <div>
          <ul className={`${classes['collection-list__product-list']} container`}>
            {mappedProducts.map(({ hoverFeature, ...product }) => (
              <RelatedProductCard
                product={product}
                key={`${product.handle}-product-collection`}
                title={product.title}
                description={product.description}
                images={product.images}
                sanityImages={product?.sanityData?.productImages}
                sourceEntryId={product.sourceEntryId}
                hoverFeature={hoverFeature}
                usePricing={usePricing}
                useFlyout={useFlyout}
                useATC={useATC}
              />
            ))}
          </ul>
        </div>

      </div>
    </section>
  )
}

export default RelatedProducts
